//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { control } from '../enum';
export default {
  data: function data() {
    return {
      activeName: 'first',
      // 组件列表
      control: control
    };
  },
  methods: {
    // 开始拖拽
    // @param Event对象 和 type当前组件对象
    handleDragStart: function handleDragStart(event, type) {
      // console.log(event, type)
      event.dataTransfer.setData('type', type);
    }
  }
};